import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as moment from 'moment';
import Pagination from '@material-ui/lab/Pagination';
import { InnerBoxesRefund, SummarySection } from './ClaimStyled'
import { downloadInvoiceOrderById, downloadCreditMemoApiCall } from '../../../../../redux/actions/admin';
import { downloadFile } from 'redux/actions/helper/downloadFile';

function Refunds(props) {
  const dispatch = useDispatch();
  let history = useHistory()
  let refundTabDataList = props.claimsDataList
  let tabType = props.tabType
  let pageNumber = props.pageNumber
  let totalPagesCount = props.totalPagesCount

  const handlePageChange = (event, value) => {
    props.onPageChange(value)
  }

  const setExpandPanelFunc = (index) => {
    props.setExpandPanelFunc(index)
  }

  const downloadImage = async (imagePath) => {
    // const fileUrl = process.env.REACT_APP_API_URL + "/order/image/" + imagePath;
    // window.open(fileUrl);
    dispatch(downloadFile(imagePath));
  };

  const downloadReceipt = async (id, authId) => {
    let token = localStorage.getItem('token')
    let response = await dispatch(downloadInvoiceOrderById(id, authId, token));

    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Receipt.pdf");
    document.body.appendChild(link);
    link.click();
  }

  const downloadCreditMemo = async (id) => {
    let token = localStorage.getItem('token')
    let response = await dispatch(downloadCreditMemoApiCall(id, token));

    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Credit Memo.pdf");
    document.body.appendChild(link);
    link.click();
  }

  return (
    <>
      {refundTabDataList && refundTabDataList.map((item, index) => {
        // for calculating the remaining quanity in case claim raised scenarios
        let actualDisplayQuantity = item.orderDetails?.quantity
        let totalClaimQuantity = 0
        let isPtDiscount = false
        if (item.claimDetails?.length > 0) {
          let ptDiscountCount = item.claimDetails.filter(val => val.adminResolutionClaimDetails?.action === 'PT_DISCOUNT')
          if (ptDiscountCount && ptDiscountCount.length > 0) isPtDiscount = true

          totalClaimQuantity = item.claimDetails.reduce((acc, value) => {
            return acc + value.claimQuality + value.claimQuantity
          }, 0)
        }
        actualDisplayQuantity = actualDisplayQuantity - totalClaimQuantity
        return (
          <>
            <InnerBoxesRefund>
              <div className='first-row'>
                <div className='mobile-resp-first-row'>
                  <p title={item.orderId?.length > 17 && item.orderId}>
                    Order Id : <span>{item.orderId?.substring(0, 17)}
                      {item.orderId?.length > 17 && <span>...</span>}</span>
                  </p>
                  <p title={item.poNumber?.length > 10 && item.poNumber}>
                    PO Number : <span>{(item.poNumber && item.poNumber !== '') ? item.poNumber.substring(0, 17) : 'NA'}</span>
                    {item.poNumber?.length > 10 && <span>...</span>}</p>
                  {tabType === 'refundClaims' ?
                    <>
                      <button onClick={() => downloadImage(item.fileBOL)}>Download BOL</button>
                      <button style={{ width: '150px' }} onClick={() => downloadReceipt(item.orderId, item.buyerAuthId)}>Download Invoice</button>
                      <button style={{ width: '180px' }} onClick={() => downloadReceipt(item.orderId, item.sellerAuthId)}>Download Remittance</button>
                    </> :
                    <>
                      <button style={{ width: '160px' }} onClick={() => downloadCreditMemo(item.buyerCreditMemoId)}>Buyer Credit Memo</button>
                      {(item.adjustmentType !== 'PT_AC' && item.adjustmentType !== 'REFUND_TAX') && <button style={{ width: '160px' }} onClick={() => downloadCreditMemo(item.sellerCreditMemoId)}>Seller Credit Memo</button>}
                    </>
                  }
                </div>
                <div style={{ textAlign: 'end' }}>
                  {props.expandPanel === index ? <h4 onClick={() => setExpandPanelFunc()}>Show Less <i></i></h4> :
                    <h5 onClick={() => setExpandPanelFunc(index)}>Show More <i></i></h5>
                  }
                </div>
              </div>
              {props.expandPanel !== index &&
                <>
                  <h3>Order Details</h3>
                  <div className='refund-second-row'>
                    <p title={item.orderDetails?.title?.length > 17 && item.orderDetails?.title}>
                      Post Name : <span>{item.orderDetails?.title?.substring(0, 17)}</span>
                      {item.orderDetails?.title?.length > 17 && <span>...</span>}
                    </p>
                    <p>Buyer Total Price : <span>$ {item.buyerInfo?.price?.totalPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></p>
                    <p>Seller Total Price : <span>$ {item.sellerInfo?.price?.totalPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></p>
                    {tabType === 'refundClaims' ?
                      <p>{item.type === 'PICKUP' ? 'Pickup Date : ' : 'Delivered Date : '}<span>{item.shippingStatusDetails ? moment(item.shippingStatusDetails[1]?.createdSellerTime).format('MM/DD/YYYY') : ''}</span></p>
                      :
                      <p>Adjusted Date : <span>{item.createdDate ? moment(item.createdDate * 1000).format('MM/DD/YYYY') : ''}</span></p>
                    }
                  </div>
                </>
              }
              {props.expandPanel === index &&
                <>
                  <div>
                    <div className='second-row'>
                      <h1>Order Details</h1>
                      <div>
                        <div><p>Order Id </p> <span>{item.orderId}</span></div>
                        {item.orderDetails?.title !== item.orderId && //this condition is for delivery vendor pricing request orders, where order id and post name are same, so no need to display post name
                          <div><p>Post Name </p> <span>{item.orderDetails?.title}</span></div>
                        }
                        <div><p>Buyer Total Price </p> <span>$ {item.buyerInfo?.price?.totalPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></div>
                        <div><p>Seller Total Price </p> <span>$ {item.sellerInfo?.price?.totalPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></div>
                        <div><p>{item.type === 'PICKUP' ? 'Pickup Date' : 'Delivered Date'}</p> <span>{item.shippingStatusDetails ? moment(item.shippingStatusDetails[1]?.createdSellerTime).format('MM/DD/YYYY') : ''}</span></div>
                        {tabType === 'refundTransclaims' && <div><p>Adjusted Date </p> <span>{item.createdDate ? moment(item.createdDate * 1000).format('MM/DD/YYYY') : ''}</span></div>}
                        <div><p>Mode </p> <span>{item.type === 'PICKUP' ? 'Pick Up' : 'Delivery'}</span></div>
                      </div>
                    </div>

                    <SummarySection>
                      <div className="mx-2 my-2 summary-section light-theme">
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(205px, 1fr))' }}>
                          <div>
                            <p className='heading-style'>Ship From</p>
                            <div className='trader-info-section'>
                              <p>{item.shipFrom?.name?.trim()}</p>
                              <p>{item.shipFrom?.line1}</p>
                              {item.shipFrom?.line2 && <p>{item.shipFrom?.line2?.trim()}</p>}
                              <p>{item.shipFrom?.city?.trim()}, {item.shipFrom?.state?.trim()}, {item.shipFrom?.zip?.trim()}</p>
                            </div>
                          </div>
                          <div>
                            <p className='heading-style'>Ship To</p>
                            <div className='trader-info-section'>
                              <p>{item.shipTo?.name?.trim()}</p>
                              <p>{item.shipTo?.line1}</p>
                              {item.shipTo?.line2 && <p>{item.shipTo?.line2?.trim()}</p>}
                              <p>{item.shipTo?.city?.trim()}, {item.shipTo?.state?.trim()}, {item.shipTo?.zip?.trim()}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mx-2 my-2 summary-section light-theme">
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(205px, 1fr))' }}>
                          <div>
                            <p className='heading-style'>Seller Info</p>
                            <div className='trader-info-section'>
                              <p>{item.sellerInfo?.companyName?.trim()}</p>
                              <p>{item.sellerInfo?.address?.line1}</p>
                              {item.sellerInfo?.address?.line2 && <p>{item.sellerInfo?.address?.line2?.trim()}</p>}
                              <p>{item.sellerInfo?.address?.city?.trim()}, {item.sellerInfo?.address?.state?.trim()} {item.sellerInfo?.address?.zip?.trim()}</p>
                            </div>
                          </div>
                          <div>
                            <p className='heading-style'>Buyer Info</p>
                            <div className='trader-info-section'>
                              <p>{item.buyerInfo?.companyName?.trim()}</p>
                              <p>{item.buyerInfo?.address?.line1}</p>
                              {item.buyerInfo?.address?.line2 && <p>{item.buyerInfo?.address?.line2?.trim()}</p>}
                              <p>{item.buyerInfo?.address?.city?.trim()}, {item.buyerInfo?.address?.state?.trim()} {item.buyerInfo?.address?.zip?.trim()}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mx-2 my-2 summary-section light-theme">
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(205px, 1fr))' }}>
                          <div className="summary-info">
                            <h6 className='heading-style'>Seller Remittance</h6>
                            <div>
                              <p>Qty</p>
                              <p>{isPtDiscount ? item.orderDetails?.quantity : actualDisplayQuantity}</p>
                            </div>
                            <div>
                              <p>Base</p>
                              <p>$ {item.orderDetails?.pricePerPallet?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                            <div>
                              <p>Total Base</p>
                              <p>$ {item.sellerInfo?.price?.productPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                            <div>
                              <p>PT Fee</p>
                              <p>$ {item.sellerInfo?.price?.serviceCharge?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                            <div><p></p><p></p></div>
                            <hr />
                            <div>
                              <p>Total Adjusted Rem</p>
                              <p>$ {item.sellerInfo?.price?.totalPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                            <div style={{ minHeight: '15px' }}></div>
                            <div>
                              <p>Account Ending In</p>
                              <p>{item.sellerInfo?.paymentMethodInfo?.paymentMethodDetails?.paymentMethod === 'BANK_ACCOUNT' ?
                                `***${item.sellerInfo?.paymentMethodInfo?.paymentMethodDetails?.bankAccount?.last4}` :
                                `***${item.sellerInfo?.paymentMethodInfo?.paymentMethodDetails?.card?.last4Digit}`}</p>
                            </div>
                            <div>
                              <p>Type</p>
                              <p>{item.sellerInfo?.paymentMethodInfo?.paymentMethodDetails?.paymentMethod}</p>
                            </div>
                          </div>
                          <div className="summary-info">
                            <h6 className='heading-style'>Buyer Receivable</h6>
                            <div>
                              <p>Qty</p>
                              <p>{actualDisplayQuantity}</p>
                            </div>
                            <div>
                              <p>Base</p>
                              <p>$ {item.orderDetails?.pricePerPallet?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                            <div>
                              <p>Total Base</p>
                              <p>$ {item.buyerInfo?.price?.productPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                            <div>
                              <p>PT Fee</p>
                              <p>$ {(item.buyerInfo?.price?.serviceCharge - item.buyerInfo?.price?.tax)?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                            <div>
                              <p>Tax</p>
                              <p>$ {item.buyerInfo?.price?.tax?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                            <hr />
                            <div>
                              <p>Total Adjusted Paya</p>
                              <p>$ {item.buyerInfo?.price?.totalPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </div>
                            <div style={{ minHeight: '15px' }}></div>
                            <div>
                              <p>Account Ending In</p>
                              <p>{item.buyerInfo?.paymentMethodInfo?.paymentMethodDetails?.paymentMethod === 'ACH_ACCOUNT' ?
                                `***${item.buyerInfo?.paymentMethodInfo?.paymentMethodDetails?.achBankAccount?.last4}` :
                                `***${item.buyerInfo?.paymentMethodInfo?.paymentMethodDetails?.card?.last4Digit}`}</p>
                            </div>
                            <div>
                              <p>Type</p>
                              <p>{item.buyerInfo?.paymentMethodInfo?.paymentMethodDetails?.paymentMethod}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SummarySection>
                  </div>
                  {tabType === 'refundTransclaims' &&
                    <div className='second-row'>
                      <h1>Adjustment Details</h1>
                      <div>
                        <div><p>Adjustment Type </p>
                          <span>
                            {item.adjustmentType === 'SELLER_AC' ?
                              'Refund to Buyer' :
                              item.adjustmentType === 'BUYER_AC' ?
                                'Charge the Buyer' :
                                item.adjustmentType === 'REFUND_TAX' ?
                                  'Tax Refund to Buyer' :
                                  'PT Overide'
                            }
                          </span>
                        </div>
                        <div><p>Adjusted Quantity </p> <span>{item.adjustmentDetails?.adjQty}</span></div>
                        {item.adjustmentType !== 'REFUND_TAX' && <div><p>Adjusted Amount </p> <span>$ {item.adjustmentDetails?.adjAmount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></div>}
                        {item.adjustmentType === 'SELLER_AC' &&
                          <>
                            <div><p>Buyer Refund Amount </p> <span>$ {item.adjustmentDetails?.buyerRefundAmount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></div>
                            <div><p>Seller Charged Amount </p> <span>$ {item.adjustmentDetails?.sellerDeductAmount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></div>
                          </>
                        }
                        {item.adjustmentType === 'BUYER_AC' &&
                          <>
                            <div><p>Buyer Charged Amount </p> <span>$ {item.adjustmentDetails?.buyerTotalPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></div>
                            <div><p>Seller Received Amount </p> <span>$ {item.adjustmentDetails?.sellerTotalPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></div>
                          </>
                        }
                        {(item.adjustmentType === 'PT_AC' || item.adjustmentType === 'REFUND_TAX') &&
                          <>
                            <div><p>Buyer Refund Amount </p> <span>$ {item.adjustmentDetails?.buyerRefundAmount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></div>
                            <div><p>PT Paid Amount </p> <span>$ {item.adjustmentDetails?.ptPaidAmount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></div>
                          </>
                        }
                        <div><p>Comments</p> <span>{item.comments}</span></div>
                      </div>
                    </div>
                  }
                  {tabType === 'refundClaims' ?
                    <div className='third-row'>
                      <div>
                        <button id='adjustmentModal' onClick={() => props.setRefundAdjustModal(true, item, 'adjustmentModal')}>Adjustment</button>
                        <button id='adjustmentPTOveride' onClick={() => props.setRefundAdjustModal(true, item, 'adjustmentPTOveride')}>Override</button>
                        <button id='refundTaxModal' onClick={() => props.setRefundAdjustModal(true, item, 'refundTaxModal')}>Refund Tax Amount</button>
                        <button id='refundTaxModal' onClick={() => props.setRefundAdjustModal(true, item, 'reverseSellerPayout')}>Reverse Seller Payout</button>
                      </div>
                    </div>
                    :
                    <div className='third-row'>
                      <div>
                        <button onClick={() => downloadImage(item.fileBOL)}>Download BOL</button>
                        <button style={{ width: '150px', background: '#5ea8ca' }} onClick={() => downloadReceipt(item.orderId, item.buyerAuthId)}>Download Invoice</button>
                        <button style={{ width: '180px' }} onClick={() => downloadReceipt(item.orderId, item.sellerAuthId)}>Download Remittance</button>
                      </div>
                    </div>
                  }
                </>
              }
            </InnerBoxesRefund>
          </>
        )
      })}
      {refundTabDataList?.length === 0 && <p style={{ textAlign: 'center' }}>No records found</p>}
      {refundTabDataList?.length !== 0 && <Pagination
        count={totalPagesCount}
        page={pageNumber}
        onChange={handlePageChange} />}
    </>
  )
}

export default Refunds